import { useMemo } from 'react';
import { buildMotorDrawerBooleanCollapsibleGroups } from '../../../../utils/electronicsDashboardUtils';
import { MetricCollapsibleDrawerSection, type MotorDrawerSectionProps } from '../DrawerDraggableLayout';

const MotorPerMotorDrawerSection = ({ motorPorts, projectCode }: MotorDrawerSectionProps) => {
  const booleanGroups = useMemo(() => buildMotorDrawerBooleanCollapsibleGroups(motorPorts, projectCode), [motorPorts, projectCode]);

  return <MetricCollapsibleDrawerSection groups={booleanGroups} />;
};

export default MotorPerMotorDrawerSection;
